<script>
import BaseComp from './BaseComp'
export default {
  name: 'interactSmartIndex',
  extends: BaseComp
}
</script>
